import { QuestionTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import {
  Invalidation,
  Quiz,
  QuizAnswer,
  QuizQuestion,
} from '~teacher/models/quizzes';

export class QuizValidation {
  validateQuiz(quiz: Quiz): {
    skipSave: boolean;
    invalidations: Invalidation[];
  } {
    const invalidations: Invalidation[] = [];
    let skipSave = false;

    if (!quiz.name || quiz.name.length === 0) {
      invalidations.push({
        title: translate('Quiz Name'),
        description: translate('Please enter a name for your quiz.'),
      });
    }

    if (quiz.questions.length === 0) {
      // Skip saving if the quiz is empty of questions and its brand new
      skipSave = quiz.lastUpdated === null;
      invalidations.push({
        title: translate('Incomplete Quiz'),
        description: translate('A quiz must have at least one question.'),
      });
    }

    return { skipSave: skipSave, invalidations: invalidations };
  }

  validateQuestion(
    question: QuizQuestion,
    answerMapping: Record<string, QuizAnswer>
  ): Invalidation[] {
    const invalidations: Invalidation[] = [];
    const meta = `${translate('Question')} ${question.order}`;
    const answerKeys = answerMapping ? Object.keys(answerMapping) : [];
    const nonEmptyAnswerKeys = answerKeys.filter((key) => {
      const answer: QuizAnswer = answerMapping[key];
      const hasText = answer.text && answer.text.length > 0;
      return hasText || answer.image;
    });

    switch (question.type) {
      case QuestionTypes.MultipleChoice:
        if (nonEmptyAnswerKeys.length < 2) {
          invalidations.push({
            title: translate('Missing Answers'),
            description: translate(
              'Multiple-choice questions must have at least two answers.'
            ),
            meta: meta,
          });
        }
        break;
      default:
      // Do nothing
    }
    const hasQuestionText =
      question.questionText && question.questionText.length > 0;
    if (
      !hasQuestionText &&
      !question.questionImage &&
      !question.questionVideo
    ) {
      invalidations.push({
        title: translate('Incomplete Question'),
        description: translate(
          'You must pose a question including either text, an image, or a video.'
        ),
        meta: meta,
      });
    }

    return invalidations;
  }
}
